import {
  IconActionHistory, IconArrowLeft, IconArrowRight, IconLogOut,
  IconProducts,
  IconProfile,
  IconStatistics,
  IconStores
} from '@touche-lts/panel-ui/dist'
import { IconOrders } from '@touche-lts/panel-ui/dist/assets/svg'
import { IconAddress, IconPayment } from 'assets/icons'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { MyStorePaths, getMyStorePath, getMyStoreProductsPath, getMyStoreStatisticsPath } from 'routes'
// import { getLogoImageSrcForObj } from 'utilities'
import styles from './side-menu.module.scss'
import { SideMenuProps } from './side-menu.types'
import { SideMenuUI } from '../../common/side-menu'

const SideMenuComponent = (props: SideMenuProps) => {
  // const { className, style } = props
  const {
    userStore: { assignedStore: store, clearStoredDate, viewerMenuVisible, setViewerMenuVisible, managementStoreId },
    routingStore: { push, location }
  } = useRootStore()

  // const userDetails = JSON.parse(localStorage.getItem('userDetails'));

  const handleLogOut = () => {
    clearStoredDate()
    window.location.replace('/');
  }

  if (window.location.href.indexOf('/account') === -1) {
    setViewerMenuVisible(false);
  }

  return (
    <>
      {!!store ? ( // Side menu admin
        < SideMenuUI
          iconArrowLeft={IconArrowLeft}
          iconArrowRight={IconArrowRight}
          isUserAuthenticated={true}
          className={styles.sideMenu}
          navMenu={
            [
              {
                label: 'My store',
                icon: IconStores,
                isSelected: location.pathname === MyStorePaths.ROOT || /^\/my-store\/\d+$/.test(location.pathname),
                onClick: () => push(getMyStorePath(managementStoreId)),
                notAllowedForLoggedUser: false
              },
              {
                label: 'Orders',
                icon: IconOrders,
                isSelected: location.pathname.startsWith(MyStorePaths.ORDERS), // For select tab
                onClick: () => push(MyStorePaths.ORDERS),
                notAllowedForLoggedUser: false
              },
              {
                label: 'Products',
                icon: IconProducts,
                isSelected: location.pathname.startsWith(MyStorePaths.PRODUCTS) || /^\/my-store\/\d+\/products/.test(location.pathname), // For select tab
                onClick: () => push(getMyStoreProductsPath(managementStoreId)),
                notAllowedForLoggedUser: false
              },
              {
                label: 'Statistics',
                icon: IconStatistics,
                isSelected: location.pathname.startsWith(MyStorePaths.STATISTICS) || /^\/my-store\/\d+\/statistics/.test(location.pathname), // For select tab
                onClick: () => push(getMyStoreStatisticsPath(managementStoreId)),
                notAllowedForLoggedUser: false
              },
              {
                label: 'My action history',
                icon: IconActionHistory,
                isSelected: location.pathname.startsWith(MyStorePaths.ACTION_HISTORY), // For select tab
                onClick: () => push(MyStorePaths.ACTION_HISTORY),
                notAllowedForLoggedUser: false
              },
              {
                label: 'Log out',
                icon: IconLogOut,
                isSelected: false,
                onClick: () => handleLogOut(),
                notAllowedForLoggedUser: false
              }
            ]
          }
        />
      ) : ( // Side menu customer
        <>
          {viewerMenuVisible && (
            <SideMenuUI
              iconArrowLeft={IconArrowLeft}
              iconArrowRight={IconArrowRight}
              isUserAuthenticated={true}
              className={styles.sideMenu}
              navMenu={
                [
                  {
                    label: 'Account Details',
                    icon: IconProfile,
                    isSelected: location.pathname === MyStorePaths.ACCOUNT_DETAILS,
                    onClick: () => push(MyStorePaths.ACCOUNT_DETAILS),
                    notAllowedForLoggedUser: false
                  },
                  {
                    label: 'Orders',
                    icon: IconOrders,
                    isSelected: location.pathname.startsWith(MyStorePaths.ACCOUNT_ORDERS),
                    onClick: () => push(MyStorePaths.ACCOUNT_ORDERS),
                    notAllowedForLoggedUser: false
                  },
                  {
                    label: 'Addresses',
                    icon: IconAddress,
                    isSelected: location.pathname.startsWith(MyStorePaths.ACCOUNT_ADDRESSES),
                    onClick: () => push(MyStorePaths.ACCOUNT_ADDRESSES),
                    notAllowedForLoggedUser: false
                  },
                  {
                    label: 'Payment methods',
                    icon: IconPayment,
                    isSelected: location.pathname.startsWith(MyStorePaths.ACCOUNT_PAYMENT),
                    onClick: () => push(MyStorePaths.ACCOUNT_PAYMENT),
                    notAllowedForLoggedUser: false
                  },
                  {
                    label: 'Log out',
                    icon: IconLogOut,
                    isSelected: false,
                    onClick: () => handleLogOut(),
                    notAllowedForLoggedUser: false
                  }
                ]
              }
            />
          )}
        </>
      )}
    </>
  )
}

const SideMenu = observer(SideMenuComponent)
export { SideMenu }
